export default __webpack_public_path__ + "static/media/silver.157aefcb.svg";